import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const b = localStorage.getItem("ih_builder");
  if (b) cfg.headers["X-Builder-Id"] = b;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export const asset = (u) => (!u ? "" : u.startsWith("/api/") ? `${BACKEND}${u}` : u);
export const money = (v) => "$" + Math.round(v || 0).toLocaleString("en-CA");

export function taxFor(b, total) {
  const rate = Number(b?.tax_rate ?? 5) || 0;
  const included = !!b?.prices_include_tax;
  const tax = included ? (total * rate) / (100 + rate) : (total * rate) / 100;
  return {
    label: b?.tax_label || "GST", rate, included, tax: Math.round(tax),
    grand: Math.round(included ? total : total + tax),
    note: b?.rebate_note ?? "You may be eligible for a GST/HST new housing rebate. Ask our sales team for details.",
  };
}

export function TaxLines({ builder, total, className = "" }) {
  const t = taxFor(builder, total);
  return (
    <div className={className} data-testid="tax-lines">
      {!t.included && <div className="flex justify-between text-sm text-slate-600"><span>Subtotal</span><span>{money(total)}</span></div>}
      <div className="flex justify-between text-sm text-slate-600"><span>{t.included ? "Includes " : ""}{t.label} ({t.rate}%)</span><span data-testid="tax-amount">{money(t.tax)}</span></div>
      <div className="flex justify-between items-end pt-2"><span className="font-serif text-xl">Total <span className="text-xs font-sans text-slate-500">incl. {t.label}</span></span><span className="font-serif text-3xl text-bp" data-testid="tax-grand-total">{money(t.grand)}</span></div>
      {t.note && <p className="text-[11px] text-slate-500 mt-2 leading-snug" data-testid="tax-rebate-note">{t.note}</p>}
    </div>
  );
}

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return (typeof e === "string" && e) || e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

export function sessionId() {
  let s = localStorage.getItem("ih_sid");
  if (!s) {
    s = (window.crypto?.randomUUID?.() || String(Date.now()) + Math.random().toString(16).slice(2));
    localStorage.setItem("ih_sid", s);
  }
  return s;
}

export function track(ev) {
  api.post("/public/events", { ...ev, session_id: sessionId() }).catch(() => {});
}

export function beacon(ev) {
  const blob = new Blob([JSON.stringify({ ...ev, session_id: sessionId() })], { type: "application/json" });
  if (!navigator.sendBeacon?.(`${BACKEND}/api/public/events`, blob)) track(ev);
}

export function applyTheme(b) {
  if (!b) return;
  const r = document.documentElement.style;
  r.setProperty("--bp", b.primary_color || "#1E293B");
  r.setProperty("--ba", b.accent_color || "#D4A12A");
}

export const STATUS = {
  available: { label: "Available", pin: "#10B981", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  reserved: { label: "Reserved", pin: "#F59E0B", cls: "bg-amber-50 text-amber-800 border-amber-300" },
  sold: { label: "Sold", pin: "#EF4444", cls: "bg-rose-50 text-rose-800 border-rose-300" },
};
